// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrueTag_wrapper__16SDV","title":"TrueTag_title__29ZKA","deleteIcon":"TrueTag_deleteIcon__2zS8E"};